export type InvoiceItemMoveTicketModel = {
    id: number;
    name: string;
    is_inventory: boolean;
    total_inventory?: number;
    ticket_tally?: {
        id: number;
        total_sold?: number;
    }
}

export type InvoiceItemMoveEventModel = {
    id: number;
    title: string;
    starts_at: string;
    ends_at: string;
    timezone: string;
    tickets: InvoiceItemMoveTicketModel[];
}

export const InvoiceItemMoveEventFragment = `
    id
    title
    starts_at
    ends_at
    timezone
    tickets {
        id
        name
        is_inventory
        total_inventory
        ticket_tally {
            id
            total_sold
        }
    }
`